import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import api from "../../services/api";

const SendFlowModal = ({ open, onClose, ticketId }) => {
  const [flows, setFlows] = useState([]);
  const [flowId, setFlowId] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFlowId("");
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        setFlows(data?.flows || []);
      } catch (err) {
        toast.error("Não foi possível carregar os fluxos");
      }
    })();
  }, [open]);

  const handleSend = async () => {
    if (!flowId) return toast.error("Selecione um fluxo");
    setSending(true);
    try {
      await api.post(`/tickets/${ticketId}/send-flow`, { flowId });
      toast.success("Fluxo enviado. O atendimento foi para Automação.");
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.error;
      toast.error(msg || "Não foi possível enviar o fluxo");
    }
    setSending(false);
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Enviar fluxo de automação</DialogTitle>
      <DialogContent dividers>
        <TextField
          select
          fullWidth
          variant="outlined"
          label="Fluxo"
          value={flowId}
          onChange={(e) => setFlowId(e.target.value)}
        >
          {flows.map((f) => (
            <MenuItem key={f.id} value={f.id}>
              {f.name}
            </MenuItem>
          ))}
        </TextField>
        <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 12 }}>
          O fluxo começa agora para este contato. O atendimento sai do atendente e vai para a aba
          Automação até o fluxo terminar ou transferir.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSend} color="primary" variant="contained" disabled={sending || !flowId}>
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendFlowModal;
